import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomePageService {

  url = environment.serverAPI4 + '/api/layout';

  constructor(private http: HttpClient) { }


  getLayoutDetails(number:any): Observable<Object> {
    return this.http.get(`${this.url}/${number}`);
  }

  copyTemplate(number:any): Observable<Object> {
    return this.http.get(`${this.url}/${number}/copy`);
  }

  getLayoutUuid(uuid:any): Observable<Object> {
    return this.http.get(`${this.url}/${uuid}`);
  }
  saveLayout(layout: any): Observable<Response[]> {

		return this.http.post<Response[]>(`${this.url}`, layout);
	}

	copyLayout(layout: any): Observable<Response[]> {

		return this.http.post<Response[]>(`${this.url}/copy`, layout);
	}
	delete(layout:any): Observable<Object> {

		let headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		let options = {
			headers: headers,
			body: layout
		}
		return this.http.delete(`${this.url}`, options);
	}

	 getPrimaryDetals(): Observable<Object> {
    return this.http.get(`${this.url}/default/uuId`);
  }

  
}
